import { HttpBackend, HttpClient, HttpParams, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthIotInterceptor } from './interceptor/auth-iot-core.interceptor';

@Injectable({
  providedIn: 'root'
})
export class IotCoreGAMCService {

  private _http: HttpClient;
  private _iotBaseUrl: string = 'https://iot-core.cochabamba.bo/api';

  constructor(private injector: Injector,
              private httpBackend: HttpBackend) {
    const authInterceptor = this.injector.get(AuthIotInterceptor);
    const handler = {
      handle: (req: HttpRequest<any>) => authInterceptor.intercept(req, this.httpBackend)
    };
    this._http = new HttpClient(handler as HttpHandler);
  }

  public getGatewayList(limit: number = 10, offset: number = 0): Observable<any> {
    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());

    return this._http.get(`${this._iotBaseUrl}/gateways/`, { params });
  }

  public getSensorList(limit: number = 100, offset: number = 2): Observable<any> {
    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());

    return this._http.get(`${this._iotBaseUrl}/sensors/`, { params });
  }
}